import axios from './axiosInstance';

export const getHealersByModality = async ({
  modality
}) => {

  const params = {
    modality : modality
  }
  try {
    const response = await axios({
      url: '/get-healers-by-modality',
      method: 'GET',
      params : params
    })

    return ({
      data: response.data,
      error: null
    })

  } catch (error) {
    return {
      data: null,
      error: error
    }
  }
}

export const saveSuggestedHealersByModalty = async ({
  modality,
  healers
}) => {
  try {
    const response = await axios({
      url: '/add-suggested-healers-by-modality',
      method: 'POST',
      data : {
        modality : modality,
        healers : healers
      }
    })

    return ({
      data: response.data,
      error: null
    })

  } catch (error) {
    return {
      data: null,
      error: error
    }
  }
}